import { render, staticRenderFns } from "./placeholderImg.vue?vue&type=template&id=ebc5ae40&scoped=true&"
import script from "./placeholderImg.vue?vue&type=script&lang=js&"
export * from "./placeholderImg.vue?vue&type=script&lang=js&"
import style0 from "./placeholderImg.vue?vue&type=style&index=0&id=ebc5ae40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc5ae40",
  null
  
)

export default component.exports